const DEFAULT_LOCAL_CLD_URL = "http://localhost:5046/";

const readProcessEnv = (name: string): string | undefined => {
  if (typeof process === "undefined") {
    return undefined;
  }

  return process.env?.[name];
};

const ensureTrailingSlash = (url: string) =>
  url.endsWith("/") ? url : `${url}/`;

export const getLocalCldUrl = () => {
  const configuredUrl =
    readProcessEnv("NUXT_PUBLIC_CLD_CORE_URL") ||
    readProcessEnv("CLD_CORE_URL") ||
    DEFAULT_LOCAL_CLD_URL;

  return ensureTrailingSlash(configuredUrl);
};
